export { ResidentStatusesField } from './ResidentStatusesField';
